import { render, staticRenderFns } from "./ShareModal.vue?vue&type=template&id=0f539567&"
import script from "./ShareModal.vue?vue&type=script&lang=js&"
export * from "./ShareModal.vue?vue&type=script&lang=js&"
import style0 from "./ShareModal.vue?vue&type=style&index=0&id=0f539567&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports